import * as React from 'react';
import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

registerCardTemplate({
    id: 'box-chart',
    name: 'Box chart',
    description: 'box chart',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-box-chart" */ "./BoxChart")),
    icon: <div>
        <svg width="58" height="24" viewBox="0 0 58 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="57" height="23" rx="2.5" fill="#D9D9D9" stroke="#424242" />
            <path d="M1.87097 3.08694C1.87097 2.53466 2.31869 2.08694 2.87097 2.08694H14.0323V21.913H2.87097C2.31869 21.913 1.87097 21.4653 1.87097 20.913V3.08694Z" fill="#424242" />
            <path d="M30.871 2.08694H43.0323V21.913H30.871V2.08694Z" fill="#424242" />
            <path d="M50.5161 2.08694H55.129C55.6813 2.08694 56.129 2.53466 56.129 3.08694V20.913C56.129 21.4653 55.6813 21.913 55.129 21.913H50.5161V2.08694Z" fill="#424242" />
            <path d="M14.0323 2.08694H22.4516V21.913H14.0323V2.08694Z" fill="white" />
            <path d="M22.4516 2.08694H30.871V21.913H22.4516V2.08694Z" fill="white" />
            <path d="M42.0968 2.08694H50.5161V21.913H42.0968V2.08694Z" fill="white" />
        </svg>

    </div>,
    complexity: 'easy',
    preLoader: 'donut-chart',
    expectedSchema: 'dictionary-array',
    canDragDropFields: true
});
